import { IDelimiter } from "./use-gauge";

export const degreesToRadians = (degrees: number) => {
  return (degrees * Math.PI) / 180;
};

export const makeTickMarks = (minAngle: number, maxAngle: number, delimiters: IDelimiter[]) => {
  const tickMarks: number[] = [];
  const angleRange = maxAngle - minAngle;

  const valueToAngle = (value: number) => {
    const valueRange = 100;
    const angle = minAngle + (value / valueRange) * angleRange;
    return Math.round(angle);
  };

  delimiters.forEach(({ endAngle }, i) => {
    const angle = i + 1 === delimiters.length ? endAngle : endAngle + 1;
    tickMarks.push(valueToAngle(angle));
  });

  return [90, ...tickMarks].reverse();
};

export const polarToCartesian = (centerX: number, centerY: number, radius: number, angleInDegrees: number) => {
  const angleInRadians = degreesToRadians(angleInDegrees);

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};
